module.exports = __webpack_public_path__ + "static/media/waitlist-bg.da2dbb37.svg";